import { useCallback, useState } from 'react';

export const toErrorMessage = (err: unknown, fallback: string): string =>
    err instanceof Error && err.message ? err.message : fallback;

export const useRequestState = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const run = useCallback(async <T,>(task: () => Promise<T>, fallbackError: string): Promise<T | null> => {
        setLoading(true);
        setError(null);
        try {
            return await task();
        } catch (err) {
            setError(toErrorMessage(err, fallbackError));
            return null;
        } finally {
            setLoading(false);
        }
    }, []);

    const reset = useCallback(() => setError(null), []);

    return { loading, error, setError, run, reset };
};
